import { Navigate, useParams } from 'react-router-dom';

import { useGetArea } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveAreaPage } from '../../shared/saveAreas';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateAreaPageInterface {}

const UpdateAreaPage: React.FC<UpdateAreaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_area);
  const { id } = useParams();
  const { data, isLoading } = useGetArea(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_area) return <Navigate to="/parametrizacion/areas" />;

  return <SaveAreaPage titlePage="Editar Area" editArea={data.data} />;
};

export default UpdateAreaPage;
